<template>
  <v-dialog
    v-model="dialog"
    persistent
    transition="dialog-bottom-transition"
    max-width="1000"
    v-if="serverData"
  >
    <!--begin::Modal dialog-->
    <div class="bg-white poppins">
      <!--begin::Modal header-->
      <div class="modal-header py-4 align-center">
        <h4 class="mb-0 font-weight-bolder">{{ headerText }}</h4>
        <!--begin::Close-->
        <div
          class="btn btn-sm btn-icon btn-active-light-info"
          @click="toggleModal"
        >
          <span class="svg-icon">
            <v-icon size="22">mdi-close</v-icon>
          </span>
        </div>
        <!--end::Close-->
      </div>
      <!--end::Modal header-->
      <!--begin::Modal body-->
      <div class="modal-body d-flex flex-column scroll-y mx-5 mx-xl-15 py-7">
        <!--begin::Body-->
        <form class="py-3 row">
          <div class="h-75px my-0 col-12 col-md-6">
            <v-autocomplete
              v-model="formData.apply_type"
              label="Apply type"
              :items="serverData.apply_types"
              item-name="text"
              item-value="index"
              clearable
              dense
              outlined
              :error-messages="apply_typeErrors"
              @input="$v.formData.apply_type.$touch()"
              @blur="$v.formData.apply_type.$touch()"
            />
          </div>
          <div class="h-75px my-0 col-12 col-md-6">
            <v-text-field
              v-model="formData.field"
              label="Field"
              clearable
              dense
              outlined
              :error-messages="fieldErrors"
              @input="$v.formData.field.$touch()"
              @blur="$v.formData.field.$touch()"
            />
          </div>

          <div class="h-75px my-0 col-12 col-md-6">
            <v-text-field
              v-model="formData.filter_field"
              label="Filter field"
              clearable
              dense
              outlined
              hide-details
            />
          </div>

          <div class="h-75px my-0 col-12 col-md-6">
            <v-autocomplete
              v-model="formData.operator"
              label="Operator"
              :items="serverData.operators"
              item-name="text"
              item-value="index"
              clearable
              dense
              outlined
              :error-messages="operatorErrors"
              @input="$v.formData.operator.$touch()"
              @blur="$v.formData.operator.$touch()"
            />
          </div>

          <div class="h-75px my-0 col-12 col-md-6">
            <v-text-field
              v-model="formData.filter_value"
              label="Filter value"
              clearable
              dense
              outlined
              :error-messages="filter_valueErrors"
              @input="$v.formData.filter_value.$touch()"
              @blur="$v.formData.filter_value.$touch()"
            />
          </div>

          <div class="h-75px my-0 col-12 col-md-6">
            <v-autocomplete
              v-model="formData.return_value_type"
              label="Return value type"
              :items="serverData.return_value_types"
              item-name="text"
              item-value="index"
              dense
              outlined
            />
          </div>

          <div class="h-75px my-0 col-12 col-md-6">
            <v-text-field
              v-model="formData.return_field"
              label="Return field"
              clearable
              dense
              outlined
              :error-messages="return_fieldErrors"
              @input="$v.formData.return_field.$touch()"
              @blur="$v.formData.return_field.$touch()"
            />
          </div>

          <div class="h-75px my-0 col-12 col-md-6">
            <v-autocomplete
              v-model="formData.target_column"
              label="Target column"
              :items="targetColumnItems"
              item-name="text"
              item-value="index"
              clearable
              dense
              outlined
              :error-messages="target_columnErrors"
              @input="$v.formData.target_column.$touch()"
              @blur="$v.formData.target_column.$touch()"
            />
          </div>
          <!--end::Body-->
        </form>

        <!--begin::Actions-->
        <div class="my-4 d-flex flex-grow-1 align-end justify-center mt-10">
          <button
            type="reset"
            class="btn btn-light mr-3 px-5 py-3 ls1"
            @click="resetForm"
          >
            Clear
          </button>
          <button
            type="submit"
            class="btn btn-info px-5 py-3 ls1"
            @click="submitForm"
          >
            {{ submitButtonText }}
          </button>
        </div>
        <!--end::Actions-->
      </div>
      <!--end::Modal body-->
    </div>
    <!--end::Modal dialog-->
  </v-dialog>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, requiredIf } from "vuelidate/lib/validators";
// import Swal from "sweetalert2";
// import { addItemMessage } from "@/core/constants/globalVariables";
import ApiService from "@/core/services/api.service";
import swalEdited from "@/core/services/AlertServices/SwalEdited";
import swalAdded from "@/core/services/AlertServices/SwalAdded";

export default {
  name: "ActionsDialog",
  mixins: [validationMixin],
  validations: {
    formData: {
      // integration_id: { required },
      apply_type: { required },
      field: { required },
      return_field: { required },
      target_column: { required },
      operator: {
        required: requiredIf(function () {
          return Boolean(this.formData.filter_field);
        }),
      },
      filter_value: {
        required: requiredIf(function () {
          return Boolean(this.formData.filter_field);
        }),
      },
    },
  },
  props: ["refresher", "pageLoader"],
  data: () => ({
    dialog: false,
    serverData: null,
    formData: {
      apply_type: null,
      field: null,
      filter_field: null,
      operator: null,
      filter_value: null,
      return_field: null,
      target_column: null,
      return_value_type: 1,
    },
  }),
  methods: {
    handleFormValidation(fieldName) {
      const errors = [];
      if (!this.$v.formData[fieldName].$dirty) return errors;
      if ("email" in this.$v.formData[fieldName]) {
        !this.$v.formData[fieldName].email &&
          errors.push("This email address is invalid");
      }
      if ("required" in this.$v.formData[fieldName]) {
        !this.$v.formData[fieldName].required &&
          errors.push("This field is required");
      }
      return errors;
    },
    loadDataFromServer() {
      this.pageLoader(true);
      if (this.actionType) {
        ApiService.post(
          "/validations/datahub/integration_payload_selectors/edit",
          {
            id: this.$store.getters.getItemForAction.id,
            integration_id: this.$store.getters.getINTEGRATIONS2IntegrationId,
          }
        )
          .then((response) => {
            this.formData = response.data.selector;
            this.serverData = response.data;

            this.pageLoader(false);
          })
          .catch(() => {
            this.dialog = false;
            this.pageLoader(false);
          });
      } else {
        ApiService.post(
          "/validations/datahub/integration_payload_selectors/create",
          {
            integration_id: this.$store.getters.getINTEGRATIONS2IntegrationId,
          }
        )
          .then((response) => {
            this.serverData = response.data;

            this.pageLoader(false);
          })
          .catch(() => {
            this.dialog = false;
            this.pageLoader(false);
          });
      }
    },
    toggleModal() {
      if (this.dialog) {
        this.resetForm();
        this.serverData = null;
      } else this.loadDataFromServer();
      this.dialog = !this.dialog;
    },

    submitForm() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.pageLoader(true);
        let data = this.formData;
        data.integration_id = this.$store.getters.getINTEGRATIONS2IntegrationId;

        if (this.actionType) {
          data.id = this.$store.getters.getItemForAction.id;
        }
        // console.log("data", data);
        let actionUrl = "store";
        if (this.actionType) actionUrl = "update";
        ApiService.post(
          `/validations/datahub/integration_payload_selectors/${actionUrl}`,
          data
        )
          .then(() => {
            if (this.actionType) swalEdited();
            else swalAdded();
            this.toggleModal();
            this.refresher();
          })
          .catch(() => {
            this.pageLoader(false);
          });
      }
    },
    resetForm() {
      this.$v.$reset();
      this.formData = {
        apply_type: null,
        field: null,
        filter_field: null,
        operator: null,
        filter_value: null,
        return_field: null,
        target_column: null,
        return_value_type: 1,
      };
    },
  },
  computed: {
    // if true, we are editing item, false we are adding
    actionType: function () {
      return !!this.$store.getters.getItemForAction;
    },
    submitButtonText: function () {
      if (this.actionType) return "Update";
      else return "Submit";
    },
    headerText: function () {
      if (this.actionType) return "Edit Item";
      else return "Add New Item";
    },
    apply_typeErrors() {
      return this.handleFormValidation("apply_type");
    },
    fieldErrors() {
      return this.handleFormValidation("field");
    },
    operatorErrors() {
      return this.handleFormValidation("operator");
    },
    filter_valueErrors() {
      return this.handleFormValidation("filter_value");
    },
    return_fieldErrors() {
      return this.handleFormValidation("return_field");
    },
    target_columnErrors() {
      return this.handleFormValidation("target_column");
    },
    targetColumnItems() {
      if (!this.formData.apply_type) {
        return [];
      }
      return this.formData.apply_type === 1
        ? this.serverData.order_target_columns
        : this.serverData.sku_target_columns;
    },
  },
};
</script>
